import Box from "@mui/material/Box"
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import dynamic from "next/dynamic";
import { useEffect } from "react";
import { useRouter } from "next/router";
import Grid  from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import useWindowSize from "@components/_hooks/useWindowSize";
import PrimaryAction from "@components/Components/Reusables/Buttons/PrimaryAction";

const StyledBox = dynamic(() => import('@components/Custom/Box/StyledBox'), )
const GlobalButton= dynamic(() => import('@components/Components/GlobalButton/GlobalButton'))
const ProductAddToQuote = dynamic(() => import('@components/Custom/Buttons/ProductAddToQuote'))
const PadSelector = dynamic(() => import('@components/Components/Reusables/PadSelector'), {
    ssr: false
})


const buttonSx = {
    background: 'none',
    overflow: 'hidden',
    border: 'none',
    pl: '1px',
    pr: '1px',
    width: '10px',
    borderRadius: 6,
    ':hover': {
        backgroundColor: 'lightgrey',
        transition: 'none',
        transform: 'none'
    }
}

const ProductAddToCart = ({source, product, props, cartControls , new_price}) => {
    const {isMobile, width}= useWindowSize()
    // const dispatch = useDispatch();
    // console.log(product)
    const router = useRouter();
    const cancelPadSelection = () => {
        setShowPadSelector(false)
    }
    
    const sectionID = 1;
    const type = 'content';
    // console.log(props.price_breaks)
    const { 
        checkProduct,
        addToCart,
        handleQtyChange,
        padSelector,
        setShowPadSelector,
        handlePadSelector,
        select,
        handleSelect,
        qty,
        setQty,
        handleExtra
     } = cartControls;

     useEffect(() => {
        const field = document.querySelector(`#product-${product.product_id}`);
        if(field){
            document.querySelector(`#product-${product.product_id}`).value = 1;
        }
        setQty(false);
     }, [router])

     const handleAddToCart = () => {
        handleExtra(product, qty[product.product_id]);
        addToCart(product.product_id, product.product_slug, qty[product.product_id], product.bow_color_option, product.pad_color_option, product.color, source, sectionID)
     }
     

  return (
    <Box className="pt-0 mt-3">
    
    <Grid spacing={2} container>
        {product?.package_core_group_id == null && (
            <Grid item>
                <Box 
                    sx={{ 
                        display: 'flex', 
                        alignItems: 'center',
                        borderRadius: '20px',
                        border: '1px solid var(--color-primary)',
                        width: '185px'
                    }}
                >
                <GlobalButton 
                    default_classes=""
                    aria-label="Decrease qty" onClick={(e) => handleQtyChange(e, product.product_id, 'subtract', true)}
                    sx={{ 
                        order: 1,
                        ...buttonSx,
                        width: '25px',
                        flex: 1,
                    }}
                    size="large"
                    >
                    <RemoveIcon />
                        
                    </GlobalButton>

                    <TextField 
                        aria-label="Product qty"
                        size="small"
                        min={1} 
                        id={`product-${product.product_id}`} 
                        onChange={(e) => handleQtyChange(e, product.product_id, null, true)}
                        sx={{
                            borderColor: 'transparent',
                            flex: 1,
                            'input': {
                                flex: 1,
                                width: '80px',
                                padding: '0.25rem',
                                textAlign: 'center',
                                padding: 0,
                                fontWeight: 'bold',
                                height: '100%',
                                '& .Mui-focused': {
                                    border: 'none',
                                    background: 'none'
                                }
                            },
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                borderColor: 'transparent', // Removes border
                                },
                                '&:hover fieldset': {
                                borderColor: 'transparent', // Removes border on hover
                                },
                                '&.Mui-focused fieldset': {
                                borderColor: 'transparent', // Removes border on focus
                                },
                            },
                            background: 'none',
                            order: 2, 
                            textAlign: 'center', 
                            width: isMobile ? '40px' : '60px', 
                            borderRadius:5, 
                            textAlign: 'center'
                        }} 
                        type="text" defaultValue={1}
                    />
                    <GlobalButton 
                        default_classes=""
                        aria-label="Increase qty" onClick={(e) => handleQtyChange(e, product.product_id, 'add', true)}
                        size="small"
                        sx={{ 
                            order: 3,
                            ...buttonSx
                        }}
                        >
                        <AddIcon />
                    </GlobalButton>
                </Box>
            </Grid>
        )}
        <Grid item>
            <StyledBox className="w-fit">
                <PrimaryAction
                    loadingButton
                    sx={{
                        zIndex:1, height:'30%',
                        border: (theme) => `1px solid ${theme.palette.primaryAction.main}`
                    }}
                    aria-label="Add to quote"
                    onClick={handleAddToCart} 
                    className="uppercase f-size_2 p-2"
                >
                    Add To Quote
                </PrimaryAction>
            </StyledBox>

        </Grid>
    </Grid>

    <Box className="mt-2">
        {padSelector && padSelector.product_id == product.product_id && padSelector.open && (
            <PadSelector 
                product={product}
                onClose={cancelPadSelection}
                handlePadSelector={handlePadSelector}
                select={select}
                onChange={handleSelect}
                props={props}
                source={source}
                sectionID={sectionID}
            />
        )}
    </Box>
</Box>
  )
}

export default ProductAddToCart